export default "__VITE_ASSET__e7ea1f4d__"